import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SkeletonAnimation } from '../../skeleton-loader.types';

@Component({
  selector: 'cm-skeleton-table',
  standalone: true,
  imports: [],
  templateUrl: './skeleton-table.component.html',
  styleUrl: './skeleton-table.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkeletonTableComponent {
  public readonly animation = input<SkeletonAnimation>('shimmer');
  public readonly tableRows = input<number>(5);
  public readonly tableColumns = input<number>(4);
}
